import { Dialog, DialogActions, DialogContent, Typography } from '@mui/material';
import PaiButton from 'features/ui/base-components/pai-button';
import PaiLink from 'features/ui/base-components/pai-link';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles } from 'tss-react/mui';
import PaiTextField from '../../ui/base-components/pai-text-field';

interface Props {
  open: boolean;
  personaName: string;
  nameTakenError: boolean | undefined;
  loading: boolean;

  handlePersonaNameChange(event: React.ChangeEvent<HTMLInputElement>): void;

  handleClose(): void;

  savePersona(): void;
}

const EnterProfileNameDialog: React.FC<Props> = ({
  open,
  personaName,
  nameTakenError,
  loading,
  handlePersonaNameChange,
  handleClose,
  savePersona,
}) => {
  const { classes } = useStyles();
  const { t } = useTranslation();

  return (
    <Dialog open={open} classes={{ paper: classes.paper }} fullWidth={true} maxWidth={'xs'}>
      <DialogContent className={classes.content}>
        <PaiTextField value={personaName} placeholder={t('enterPersonaName')} onChange={handlePersonaNameChange} />
        {nameTakenError ? <Typography className={classes.errorText}>{t('nameAlreadyTakenError')}</Typography> : null}
      </DialogContent>
      <DialogActions className={classes.actions}>
        <PaiLink text={t('cancel')} size={'sm'} underline={'always'} action={handleClose} />
        <PaiButton text={t('accept')} disabled={personaName.trim() === '' || loading} action={savePersona} />
      </DialogActions>
    </Dialog>
  );
};

const useStyles = makeStyles()((theme) => ({
  paper: {
    borderRadius: 0,
  },
  content: {
    paddingBottom: '12px',
  },
  errorText: {
    fontSize: theme.typography.pxToRem(11),
    color: theme.palette.error.main,
    marginTop: '4px',
  },
  actions: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: '16px',
    padding: '0 24px 20px 24px',
  },
}));

export default EnterProfileNameDialog;
